import { PaginationProps, SortDirection } from 'utilities'
import { GenreTypes, PersonRoles, ProjectTypes } from 'models'

export type PersonProjectsTableSearchProps = {
  name: string
  type: ProjectTypes
  role: PersonRoles
  genre: GenreTypes
  published: boolean
}

export enum PersonProjectsTableSortProps {
  NAME = 'name',
  TYPE = 'type',
  ROLE = 'role',
  GENRE = 'genre'
}

export const initialPersonProjectsPaginationProps: PaginationProps<
  PersonProjectsTableSortProps
> = {
  page: 0,
  size: 15,
  sortDirection: SortDirection.DESC,
  sortProp: PersonProjectsTableSortProps.NAME,
  totalElements: 0,
  totalPages: 0
}

export const initialPersonProjectSearchProps: PersonProjectsTableSearchProps = {
  name: '',
  type: '' as ProjectTypes,
  role: '' as PersonRoles,
  genre: '' as GenreTypes,
  published: '' as unknown as boolean
}
